import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DATE_FORMAT } from '@cl/shared/constants';
import { DepartmentPermissionsType } from '@cl/shared/department-permissions-type.enum';
import { GroupPermissionsType } from '@cl/shared/group-permissions-type.enum';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UpsertDocumentComponent } from '../upsert-document/upsert-document.component';
import { Document } from '@cl/shared/models';
import { DocumentsService } from '@cl/core/services/documents.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'cl-related-documents-list',
    standalone: false,
    templateUrl: './related-documents-list.component.html',
    styleUrl: './related-documents-list.component.less',
})
export class RelatedDocumentsListComponent {
    DATE_FORMAT = DATE_FORMAT;
    GroupPermissions = GroupPermissionsType;
    DepartmentPermissions = DepartmentPermissionsType;

    @Input() loading: boolean = false;
    @Input() documents: Document[];
    @Output() documentChanged: EventEmitter<void> = new EventEmitter<void>();

    constructor(private documentsService: DocumentsService, private modalService: NzModalService, private messageService: NzMessageService) {}

    async viewOrEditDocument(obj: Document, canEditFields: boolean = false): Promise<void> {
        this.loading = true;
        const editableObj = await (await this.documentsService.getSingle(obj.id)).data;
        this.loading = false;
        const modal = this.modalService.create({
            nzTitle: canEditFields ? 'Dokumenta labošana' : 'Dokumenta skatīšana',
            nzContent: UpsertDocumentComponent,
            nzWidth: 'fit-content',
        });

        modal.afterOpen.subscribe(() => {
            modal.getContentComponent().setEditMode(editableObj);
            modal.getContentComponent().canEditFields = canEditFields;
        });

        modal.afterClose.subscribe(async (reload) => {
            if (reload) {
                this.documentChanged.emit();
            }
        });
    }

    async deleteDocument(document: Document): Promise<void> {
        this.modalService.confirm({
            nzTitle: 'Vai tiešām vēlaties dzēst dokumentu?',
            nzCancelText: 'Atcelt',
            nzOnOk: async (): Promise<void> => {
                try {
                    this.loading = true;
                    await this.documentsService.delete(document.id);
                    this.documentChanged.emit();
                    this.messageService.success('Dokuments veiksmīgi dzēsts');
                    this.loading = false;
                } catch (ex) {
                    this.loading = false;
                    console.error(ex);
                    if (ex.error?.errors) {
                        ex.error.errors.forEach((error) => {
                            this.messageService.error(error);
                        });
                        return;
                    }

                    this.messageService.error('Kļūda dzēšot dokumentu');
                    return;
                }
            },
        });
    }
}
